import {
  OrganizationServiceCreateOrganizationGqlInput,
  OrganizationServiceUpdateOrganizationGqlInput,
  PaginationArgs,
  useOrganizationServiceAdminAllOrganizationsQuery,
  useOrganizationServiceAdminCreateOrganizationMutation,
  useOrganizationServiceAdminUpdateOrganizationMutation,
} from 'zma-react-sdk/organization-service'
import { toast } from '@/hooks/use-toast'

// Define a filter interface for organizations
export interface OrganizationFilter {
  limit?: number
  skip?: number
}

// Hook for fetching organizations list with pagination
export function useOrganizations(filter: OrganizationFilter) {
  const input: PaginationArgs = {
    limit: filter.limit || 20,
    skip: filter.skip || 0,
  }

  return useOrganizationServiceAdminAllOrganizationsQuery({
    variables: { input },
  })
}

// Hook for creating a new organization
export function useCreateOrganization(onSuccessCallback?: () => void) {
  return useOrganizationServiceAdminCreateOrganizationMutation({
    onCompleted: () => {
      toast({
        title: 'Organization created',
        description: 'The organization has been created successfully.',
      })
      onSuccessCallback?.()
    },
    onError: (error) => {
      toast({
        variant: 'destructive',
        title: 'Error creating organization',
        description:
          error?.message ||
          'An error occurred while creating the organization.',
      })
    },
    refetchQueries: ['OrganizationServiceAdminAllOrganizations'],
  })
}

// Hook for updating an organization
export function useUpdateOrganization(onSuccessCallback?: () => void) {
  return useOrganizationServiceAdminUpdateOrganizationMutation({
    onCompleted: () => {
      toast({
        title: 'Organization updated',
        description: 'The organization has been updated successfully.',
      })
      onSuccessCallback?.()
    },
    onError: (error) => {
      toast({
        variant: 'destructive',
        title: 'Error updating organization',
        description:
          error?.message ||
          'An error occurred while updating the organization.',
      })
    },
    refetchQueries: ['OrganizationServiceAdminAllOrganizations'],
  })
}

// Export types for convenience
export type {
  OrganizationServiceCreateOrganizationGqlInput,
  OrganizationServiceUpdateOrganizationGqlInput,
}
